import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/valueDataReported/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/valueDataReported/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/valueDataReported/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/valueDataReported/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/valueDataReported/update', params,options)

export const getSubjectBySort = (params, options) =>
  request.get('/api/v4ward/valueDataReported/getSubjectBySort', Object.assign({}, options, { params }))


export const getPeriodList = (params, options) =>
  request.get('/api/v4ward/valueCostBudget/getperiodlist', Object.assign({}, options, { params }))


export const getLastEndTime = (params, options) =>
  request.post('/api/v4ward/valueDataReported/getLastEndTime', params,options)

export const getSortBySubject = (params, options) =>
  request.get('/api/v4ward/valueDataReported/getSortBySubject', Object.assign({}, options, { params }))

